export const SESSION_DAYS_DURATION = 24 * 60 * 60 * 1000;
export const SESSION_HOUR_DURATION = 60 * 60 * 1000;

export const AUTO_HIDE_KEY = 'stretch-banner-autohide';
export const AUTO_HIDE_HOUR = 2;
export const AUTO_HIDE_COUNT = 'stretch-banner-count';

export const MANUAL_HIDE_KEY = 'stretch-banner-hidden';
export const MANUAL_HIDDEN_DAYS = 14;
